import React from "react"
import {
  Box,
  Typography,
  makeStyles,
  Theme,
  lighten,
  BoxProps,
} from "@material-ui/core"

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    // @ts-ignore
    backgroundColor: theme.palette.base.orange,
    // @ts-ignore
    border: `1px solid ${lighten(theme.palette.pop.orange, 0.2)}`,
    padding: theme.spacing(2),
  },
}))

interface WarningPanelProps extends BoxProps {
  warning?: string
}

export const WarningPanel: React.FC<WarningPanelProps> = ({
  warning,
  children,
  ...props
}) => {
  /** Get scoped CSS classes */
  const classes = useStyles()
  return (
    <Box className={classes.root} {...props}>
      {warning && (
        <Typography variant="body2" paragraph={Boolean(children)}>
          {warning}
        </Typography>
      )}
      {children}
    </Box>
  )
}
